export default __webpack_public_path__ + "static/media/magic_mirror.23db0e42.jpg";